import { uniqBy } from 'lodash'
import { useEffect, useMemo, useRef } from 'react'

export function useAccumulatedData<T extends { id: string }>(data: T[]) {
  const previousDataRef = useRef<T[]>([])

  const accumulatedData = useMemo(() => {
    const previousData = previousDataRef.current
    const combinedData = [...previousData, ...data]
    return uniqBy(combinedData, 'id')
  }, [data])

  useEffect(() => {
    previousDataRef.current = accumulatedData
  }, [accumulatedData])

  return accumulatedData
}
